import { Directive, ElementRef, Inject, Output } from '@angular/core';
import { fromEvent, merge, Observable, of, timer } from 'rxjs';
import { filter, map, switchMap } from 'rxjs/operators';
import { DOCUMENT } from '@angular/common';

type longPress = {
  event: any;
  isLongPress: boolean;
};

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[longPress]'
})
export class LongPressDirective {
  private _threshold = 800;
  private _startScrollPosition: number;
  @Output() public readonly longPress: Observable<number | null>;
  constructor(private elementRef: ElementRef, @Inject(DOCUMENT) private document: Document) {
    const mousedown = fromEvent<MouseEvent>(elementRef.nativeElement as HTMLElement, 'mousedown').pipe(
      filter(event => event.button === 0),
      map(event => ({
        event: event,
        isLongPress: true
      }))
    );
    const touchstart = fromEvent(elementRef.nativeElement as HTMLElement, 'touchstart').pipe(
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      map((event: any) => {
        const tag = document.getElementsByClassName('table-container');
        this._startScrollPosition = tag[0].scrollTop;
        return {
          event: event,
          isLongPress: true
        };
      })
    );
    const touchEnd = fromEvent(elementRef.nativeElement as HTMLElement, 'touchend').pipe(
      map(event => ({
        event: event,
        isLongPress: false
      }))
    );
    const mouseup = fromEvent<MouseEvent>(this.document.body, 'mouseup').pipe(
      filter(event => event.button === 0),
      map((event: MouseEvent) => ({
        event: event,
        isLongPress: false
      }))
    );

    this.longPress = merge(mousedown, mouseup, touchstart, touchEnd).pipe(
      switchMap(isLongPress => {
        if ((isLongPress as longPress).isLongPress) {
          return timer(this._threshold, 100).pipe(
            map(res => {
              const tag = document.getElementsByClassName('table-container');
              if (tag[0].scrollTop === this._startScrollPosition) {
                return res;
              }
              return null;
            })
          );
        }
        return of(null);
      }),
      filter(value => value === 0)
    );
  }
}
